import {CommonModule} from "@angular/common";
import {NgModule} from "@angular/core";
import {DialogComponent} from "./dialog.component";
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {ButtonModule} from 'primeng/button';
import {UnsafeSecurityBypassedHtmlPipe} from './html-sanitizer.pipe';
import {DynamicDialog} from 'primeng/dynamicdialog';

@NgModule({
    declarations: [
        DialogComponent
    ],
    imports: [
        CommonModule,
        FontAwesomeModule,
        ButtonModule,
        DynamicDialog,

        // Standalone Components
        UnsafeSecurityBypassedHtmlPipe,
    ],
    exports: [
        DialogComponent
    ]
})
export class DialogModule { }
